import {isEmpty} from "lodash";
import CreateEmptyObject from "@/components/mixins/CreateEmptyObject";

export default {
    mixins: [CreateEmptyObject],
    props: {
        canEdit: {
            type: Boolean,
            default: true,
        },
        creating: {
            type: Boolean,
            default: false,
        },
        alwaysEditing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            editing: this.alwaysEditing || this.creating,
            fieldErrors: {},
            nonFieldErrors: '',
        };
    },
    methods: {
        save() {
            this.resetComponent();
            this.$emit('save');
        },
        create(id) {
            this.resetComponent();
            this.$emit('create', id);
        },
        cancel() {
            this.resetComponent();
            this.$emit('cancel');
        },
        edit() {
            this.$emit('edit');
        },
        processErrors(error) {
            if (error.response.status === 404) {
                this.nonFieldErrors = this.$t('utils.notFound');
            } else {
                this.fieldErrors = error.response.data;
                let errors = [];
                for (let field in error.response.data) {
                    if (field === 'non_field_errors') {
                        errors.push(error.response.data[field]);
                    }
                }
                if (isEmpty(errors)) {
                    errors.push(this.$t('utils.errorInForm'));
                }
                this.nonFieldErrors = errors.join(', ');
            }
        },
        resetComponent() {
            this.editing = this.alwaysEditing;
            this.fieldErrors = {};
            this.nonFieldErrors = '';
        },
    },
};
